/**
 * vet-visit-menu.js
 */

import React from 'react';
import { Chip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useParams } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { Types } from 'utils/constants';
import useRecordStore from 'contexts/record-store';
import DrawerMenu from 'components/menu-drawer/menu';
import DrawerMenuItem from 'components/menu-drawer/menu/drawer-menu-item';
import { ReactComponent as ClassSVG } from 'assets/images/hospital.svg';


const useStyles = makeStyles(theme => ({
  container: {
    justifyContent: 'space-between'
  },
  title: {
    fontSize: theme.typography.sizes[1],
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  sub: {
    fontSize: theme.typography.sizes[1]
  },
  chip: {
    border: `1px solid ${theme.palette.grey.colors[7]}`,
  },
}));


export default function VetVisitMenu(props) {
  const { basePath } = props;
  const classes = useStyles();
  let params = useParams();
  let { id } = params;
  const classId = parseInt(id);
  const recordStore = useRecordStore();
  const vetVisitRecord = recordStore.useRecord(Types.Record.VET_VISIT, classId).ornull;
  const hasRecord = Boolean(vetVisitRecord);

  if (!hasRecord) {
    return null;
  }

  const now = new Date();
  const isFuture = (parseISO(vetVisitRecord.get().date) > now); 
  
  const label = (
    <div className={`flex-hc ${classes.container}`}>
      <div style={{ overflow: 'hidden' }}>
        <div className='flex-hc'>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {/* name */}
            <Typography
              variant="body2"
              className={classes.title}
            >
              {vetVisitRecord.get().name}
            </Typography>

            {/* date */}
            <Typography
              variant="body2"
              className={classes.sub}
            >
              {format(parseISO(vetVisitRecord.get().date), 'MMM dd, yyyy h:mm aaa')}
            </Typography>

            {/* location */}
            {vetVisitRecord.get().location &&
            <Typography
              variant="body2"
              className={classes.sub}
            >
                {vetVisitRecord.get().location}
            </Typography>}

          </div>
        </div>
      </div>

      {/* completion chip */}
      <div>
        <Chip
          label={isFuture ? 'Upcoming' : 'Complete'}
          size="small"
          className={`${classes.chip} ${isFuture ? 'chip-upcoming chip-font-upcoming' : 'chip-complete chip-font-complete'}`}
        />
      </div>
    </div>
  );


  return (
    <>
      <DrawerMenu 
        menuGroups={[{
          name: '',
          items: <>
            <DrawerMenuItem
              id={`class-${vetVisitRecord.get().id}`}
              iconName='vet-visit'
              label={label}
              to={null}
              noBGHover
              isActive={true}
            />
          </>
        }]} 
        footer={<ClassSVG />}
      />
    </>
  );
}